import { Radio } from 'src/shared/design-system/Radio';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const RadioContainer = styled.div`
  background-color: ${Colors.GRAY_LITE_30};

  &:active {
    background-color: ${Colors.GRAY_LITE_30};
  }

  &:not(:first-child) {
    margin-top: ${Spacing.THREE_QUARTERS};
  }

  & ${Radio} {
    padding-left: ${Spacing.SINGLE};

    &,
    & > * {
      width: 100%;
    }
  }

  @media (max-width: ${ScreenWidth.SMALL}) {
    &:active {
      background-color: ${Colors.GRAY_LITE_20};
    }
  }
`;

export const RadioHeader = styled.div`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: 400;
  font-size: ${Font.Size.S};
  line-height: ${Font.LineHeight.XXS};
  color: ${Colors.GRAY_DARK_30};
  margin-bottom: 7px;
`;

export const RadioInfo = styled.div`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  font-size: ${Font.Size.XXS};
  line-height: ${Font.LineHeight.XXXS};
  color: ${Colors.GRAY_DARK_10};
`;

export const RadioInfoLink = styled.div`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  font-size: ${Font.Size.XXS};
  line-height: ${Font.LineHeight.XXXS};
  color: ${Colors.AQUA_DARK_10};
`;

export const RadioInfoNote = styled.div`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XXS};
  line-height: ${Font.LineHeight.XXXS};
  color: ${Colors.GRAY_DARK_10};
`;

export const RadioContent = styled.div`
  margin-top: ${Spacing.SINGLE} !important;
  margin-bottom: ${Spacing.SINGLE} !important;
`;
